// index.php（トップページ）の見積もりシミュレーター＋お問い合わせフォームのJS。
// SHIPPING_RATES / HOME_SURCHARGE は index.php 側の小さなインラインscriptでこのファイルより先に読み込まれる。
(function () {
  'use strict';

  const form       = document.getElementById('estimateForm');
  const estimateInputFields = document.getElementById('estimateInputFields');
  const estimateSubmitWrap  = document.getElementById('estimateSubmitWrap');
  const resultArea = document.getElementById('estimateResult');
  const resultRows = document.getElementById('resultRows');
  const errorsEl   = document.getElementById('estimateErrors');
  const submitBtn  = document.getElementById('estimateSubmit');
  const sizeNote   = document.getElementById('sizeNote');
  const toContactBtn   = document.getElementById('estimateToContactBtn');
  const addMoreBtn     = document.getElementById('addMoreBtn');
  const addMoreWrap    = document.getElementById('addMoreWrap');
  const addMoreForm    = document.getElementById('addMoreForm');
  const addMoreErrors  = document.getElementById('addMoreErrors');
  const addMoreSizeNote = document.getElementById('addMoreSizeNote');
  const grandTotalRow  = document.getElementById('grandTotalRow');
  const grandTotalVal  = document.getElementById('grandTotalVal');
  const pdfBtn         = document.getElementById('estimatePdfBtn');
  const pdfNameWrap    = document.getElementById('estPdfNameWrap');
  const resetFormBtn   = document.getElementById('resetFormBtn');
  let allEstimates = [];

  function track(eventName, params) {
    if (window.signPrintAnalytics) window.signPrintAnalytics.track(eventName, params || {});
  }

  function trackOnce(eventName, params, uniqueKey) {
    if (window.signPrintAnalytics) window.signPrintAnalytics.trackOnce(eventName, params || {}, uniqueKey);
  }

  function productType(product) {
    return product === 'poster' ? 'waterproof_poster' : 'large_sticker';
  }

  function sizeRange(data) {
    if (data.size_mode === 'standard' && data.std_size) return 'standard_' + data.std_size;
    const qty = Math.max(1, Number(data.qty) || 1);
    const areaPerPiece = (Number(data.total_area_sqm) || 0) / qty;
    if (areaPerPiece <= 1) return 'custom_up_to_1sqm';
    if (areaPerPiece <= 3) return 'custom_1_to_3sqm';
    return 'custom_over_3sqm';
  }

  function quantityRange(qty) {
    const value = Number(qty) || 0;
    if (value <= 1) return '1';
    if (value <= 5) return '2_to_5';
    if (value <= 10) return '6_to_10';
    if (value <= 50) return '11_to_50';
    return '51_plus';
  }

  function analyticsItem(data) {
    const qty = Math.max(1, Number(data.qty) || 1);
    return {
      item_id: productType(data.product),
      item_name: data.product === 'poster' ? '大型防水ポスター印刷' : '大型ステッカー印刷',
      item_category: '大型印刷',
      price: Math.round((Number(data.total_incl) || 0) / qty),
      quantity: qty,
    };
  }

  function trackEstimateStart(product) {
    const type = productType(product);
    trackOnce('estimate_start', {
      form_name: 'online_estimate',
      page_path: location.pathname,
      product_type: type,
    }, 'online_estimate_' + type);
  }

  form.addEventListener('input', function () { trackEstimateStart(getProduct()); });
  if (addMoreForm) {
    addMoreForm.addEventListener('input', function () { trackEstimateStart(getAddMoreProduct()); });
  }

  // ── お届け先地域・送料 ──────────────────────────────────
  // SHIPPING_RATES / HOME_SURCHARGE はページ側の小さなインラインscript（index.php）でグローバル定義済み
  const estDestArea      = document.getElementById('estDestArea');
  const estMultiDestWrap = document.getElementById('estMultiDestWrap');
  const estMultiDest     = document.getElementById('estMultiDest');
  const estSharedRegion  = document.getElementById('estSharedRegion');
  const estSharedHome    = document.getElementById('estSharedHome');
  const estRegionPickers = document.getElementById('estRegionPickers');
  const estRegionErrors  = document.getElementById('estRegionErrors');
  const estSubtotalExclRow = document.getElementById('estSubtotalExclRow');
  const estSubtotalExclVal = document.getElementById('estSubtotalExclVal');
  const estTaxRow        = document.getElementById('estTaxRow');
  const estTaxVal        = document.getElementById('estTaxVal');
  const estItemsInclRow  = document.getElementById('estItemsInclRow');
  const estItemsInclVal  = document.getElementById('estItemsInclVal');
  const estShippingRow   = document.getElementById('estShippingRow');
  const estShippingVal   = document.getElementById('estShippingVal');
  const erItemsHandoff      = document.getElementById('er-items-handoff');
  const erMultiDestHandoff  = document.getElementById('er-multi-dest-handoff');

  function regionOptionsHtml(selected) {
    let html = '<option value="">選択してください</option>';
    Object.keys(SHIPPING_RATES).forEach(function (key) {
      html += '<option value="' + key + '"' + (key === selected ? ' selected' : '') + '>' + esc(SHIPPING_RATES[key].label) + '</option>';
    });
    return html;
  }

  // 税別。合計は「商品・送料とも税別で合算し、最後に一度だけ課税する」方式に統一する
  // （送料の税別化_指示書_2026-09-14 2-1節・同レビュー_2026-09-15 要修正①・記録③）。
  function computeFeeExclForEstimate(region, home) {
    if (!region || !SHIPPING_RATES[region]) return 0;
    return SHIPPING_RATES[region].fee_excl + (home ? HOME_SURCHARGE_EXCL : 0);
  }

  // 税込（表示用）。fee_excl × (1+TAX_RATE) で求める（SHIPPING_RATES の fee は同じ値になる
  // よう保持されているが、ここでは fee_excl を単一の情報源にする）。
  function computeFeeInclForEstimate(region, home) {
    return Math.round(computeFeeExclForEstimate(region, home) * (1 + TAX_RATE));
  }

  // 見積もりが2件以上のときだけ「複数箇所にお届け」チェックボックスを表示する
  function updateMultiDestVisibility() {
    if (!estMultiDestWrap) return;
    estMultiDestWrap.style.display = allEstimates.length >= 2 ? '' : 'none';
  }

  function isMultiDest() {
    return !!(estMultiDest && estMultiDest.checked);
  }

  // 「複数箇所にお届け」がオフの間は、1商品目の配送先地域を他の商品にも反映する
  function syncSharedToItems() {
    if (isMultiDest() || allEstimates.length === 0) return;
    const region = allEstimates[0].region;
    const home   = !!allEstimates[0].home;
    allEstimates.forEach(function (d) { d.region = region; d.home = home; });
  }

  function updateDestMode() {
    if (estRegionErrors) estRegionErrors.style.display = 'none';
    syncSharedToItems();
    // 計算前（見積もり結果がまだ無い状態）は結果パネルを表示しない
    if (allEstimates.length > 0) renderResults();
  }

  // 商品ごとの短辺・長辺上限。PRODUCT_SIZE_LIMITS は index.php 側の小さなインラインscriptで
  // config/prices.php の PRODUCT_PRICES から生成済み（サイズ上限_修正指示書_2026-08-15）。
  function sizeLimitFor(product) {
    return PRODUCT_SIZE_LIMITS[product] || { max_short_mm: 1300, max_long_mm: 50000, label: '' };
  }

  // サーバー側 sp_validate_custom_size()（includes/pricing.php）と同じ判定・同じ文言を返す。
  // 短辺=min(幅,高さ)・長辺=max(幅,高さ)で商品ごとの上限を判定する（幅と高さの入力順によらない）。
  function validateCustomSize(product, w, h) {
    const limit = sizeLimitFor(product);
    if (w < MIN_INPUT_MM || h < MIN_INPUT_MM) {
      return '各辺は' + MIN_INPUT_MM + 'mm以上で入力してください。';
    }
    const shortSide = Math.min(w, h);
    const longSide  = Math.max(w, h);
    if (shortSide > limit.max_short_mm) {
      return '短辺は' + MIN_INPUT_MM.toLocaleString() + '〜' + limit.max_short_mm.toLocaleString() + 'mmで入力してください。（' + limit.label + '）';
    }
    if (longSide > limit.max_long_mm) {
      return '長辺は' + limit.max_long_mm.toLocaleString() + 'mmまでです。';
    }
    return null;
  }

  function getProduct() {
    const r = form.querySelector('input[name="product"]:checked');
    return r ? r.value : 'sticker';
  }

  function getAddMoreProduct() {
    const r = addMoreForm ? addMoreForm.querySelector('input[name="product"]:checked') : null;
    return r ? r.value : 'sticker';
  }

  function updateSizeNote() {
    const p = getProduct();
    const maxShort = sizeLimitFor(p).max_short_mm;
    sizeNote.textContent = '短辺は最大 ' + maxShort.toLocaleString() + 'mm、長辺は10,000mm以上も対応（要相談）';
  }

  function updateAddMoreSizeNote() {
    if (!addMoreSizeNote) return;
    const p = getAddMoreProduct();
    const maxShort = sizeLimitFor(p).max_short_mm;
    addMoreSizeNote.textContent = '短辺は最大 ' + maxShort.toLocaleString() + 'mm、長辺は10,000mm以上も対応（要相談）';
  }

  // 規格サイズ（フリー入力 / A1 / A0 など）の切り替え制御
  function setupSizeChoice(cfg) {
    function updateFields() {
      const checked = cfg.form.querySelector('input[name="size_choice"]:checked');
      const val = checked ? checked.value : 'custom';
      cfg.sizeModeInput.value = val === 'custom' ? 'custom' : 'standard';
      cfg.stdSizeInput.value  = val === 'custom' ? '' : val;
      cfg.customSizeInputs.style.display = val === 'custom' ? '' : 'none';
      if (cfg.sizeNoteEl) cfg.sizeNoteEl.style.display = val === 'custom' ? '' : 'none';
    }
    function apply() {
      const p = cfg.productGetter();
      cfg.sizeChoiceGroup.querySelectorAll('label[data-product]').forEach(function (lbl) {
        lbl.style.display = lbl.dataset.product === p ? '' : 'none';
      });
      const checked = cfg.form.querySelector('input[name="size_choice"]:checked');
      if (checked && checked.dataset.product && checked.dataset.product !== p) {
        const customRadio = cfg.form.querySelector('input[name="size_choice"][value="custom"]');
        if (customRadio) customRadio.checked = true;
      }
      updateFields();
    }
    cfg.form.querySelectorAll('input[name="size_choice"]').forEach(function (r) {
      r.addEventListener('change', updateFields);
    });
    return { apply: apply };
  }

  const mainSizeChoice = setupSizeChoice({
    form: form,
    productGetter: getProduct,
    sizeChoiceGroup: document.getElementById('sizeChoiceGroup'),
    customSizeInputs: document.getElementById('customSizeInputs'),
    sizeModeInput: document.getElementById('size_mode'),
    stdSizeInput: document.getElementById('std_size'),
    sizeNoteEl: sizeNote,
  });

  const addMoreSizeChoice = addMoreForm ? setupSizeChoice({
    form: addMoreForm,
    productGetter: getAddMoreProduct,
    sizeChoiceGroup: document.getElementById('am-sizeChoiceGroup'),
    customSizeInputs: document.getElementById('am-customSizeInputs'),
    sizeModeInput: document.getElementById('am-size_mode'),
    stdSizeInput: document.getElementById('am-std_size'),
    sizeNoteEl: addMoreSizeNote,
  }) : null;

  // 裏面（PRODUCT_BACKINGS はページ側の小さなインラインscript（index.php）でグローバル定義済み。
  // enabled=falseの選択肢は既にPHP側で除外されている）。対象商品（ステッカー）のときだけ表示し、
  // 対象外（ポスター）へ切り替えたら選択をdefaultへ戻す。
  function backingDefaultKey(options) {
    const key = Object.keys(options || {}).find(function (k) { return options[k].default; });
    return key || '';
  }

  function setupBacking(cfg) {
    function updateNote() {
      const checked = cfg.form.querySelector('input[name="backing"]:checked');
      if (cfg.noteEl) cfg.noteEl.textContent = checked ? (checked.dataset.note || '') : '';
    }
    function apply() {
      const options = PRODUCT_BACKINGS[cfg.productGetter()];
      if (options) {
        cfg.wrap.style.display = '';
      } else {
        cfg.wrap.style.display = 'none';
        const defaultKey = backingDefaultKey(PRODUCT_BACKINGS['sticker']);
        const radio = cfg.form.querySelector('input[name="backing"][value="' + defaultKey + '"]');
        if (radio) radio.checked = true;
      }
      updateNote();
    }
    cfg.form.querySelectorAll('input[name="backing"]').forEach(function (r) {
      r.addEventListener('change', updateNote);
    });
    return { apply: apply };
  }

  const mainBacking = setupBacking({
    form: form,
    productGetter: getProduct,
    wrap: document.getElementById('backingWrap'),
    noteEl: document.getElementById('backingNote'),
  });

  const addMoreBacking = addMoreForm ? setupBacking({
    form: addMoreForm,
    productGetter: getAddMoreProduct,
    wrap: document.getElementById('am-backingWrap'),
    noteEl: document.getElementById('am-backingNote'),
  }) : null;

  // ── 合計面積に応じた納期の選択可否制御（お急ぎ納期は合計10㎡以上のみ選択可） ──
  // DELIVERY_OPTIONS / STANDARD_SIZES / MIN_BILL_MM は index.php 側の小さなインラインscriptでグローバル定義済み
  function computeTotalAreaSqm(cfg) {
    const product = cfg.productGetter();
    let areaPerPiece = 0;
    if (cfg.sizeModeInput.value === 'standard') {
      const std = STANDARD_SIZES[product] && STANDARD_SIZES[product][cfg.stdSizeInput.value];
      if (std) areaPerPiece = (std.width_mm / 1000) * (std.height_mm / 1000);
    } else {
      const w = parseFloat(cfg.widthInput.value) || 0;
      const h = parseFloat(cfg.heightInput.value) || 0;
      const billW = Math.max(w, MIN_BILL_MM);
      const billH = Math.max(h, MIN_BILL_MM);
      areaPerPiece = (billW / 1000) * (billH / 1000);
    }
    const qty = parseInt(cfg.qtyInput.value, 10) || 0;
    return areaPerPiece * qty;
  }

  function setupDeliveryGuard(cfg) {
    function update() {
      const totalArea = computeTotalAreaSqm(cfg);
      let anyDisabled = false;
      Object.keys(DELIVERY_OPTIONS).forEach(function (key) {
        const opt = cfg.deliverySelect.querySelector('option[value="' + key + '"]');
        if (!opt) return;
        const minArea = DELIVERY_OPTIONS[key].min_area_sqm || 0;
        const disabled = totalArea < minArea;
        opt.disabled = disabled;
        if (disabled) anyDisabled = true;
        if (disabled && cfg.deliverySelect.value === key) {
          cfg.deliverySelect.value = 'batch';
        }
      });
      if (cfg.deliveryNoteEl) cfg.deliveryNoteEl.style.display = anyDisabled ? '' : 'none';
    }
    cfg.form.addEventListener('input', update);
    cfg.form.addEventListener('change', update);
    update();
    return { update: update };
  }

  const mainDeliveryGuard = setupDeliveryGuard({
    form: form,
    productGetter: getProduct,
    sizeModeInput: document.getElementById('size_mode'),
    stdSizeInput: document.getElementById('std_size'),
    widthInput: document.getElementById('width_mm'),
    heightInput: document.getElementById('height_mm'),
    qtyInput: document.getElementById('qty'),
    deliverySelect: document.getElementById('delivery'),
    deliveryNoteEl: document.getElementById('deliveryAreaNote'),
  });

  const addMoreDeliveryGuard = addMoreForm ? setupDeliveryGuard({
    form: addMoreForm,
    productGetter: getAddMoreProduct,
    sizeModeInput: document.getElementById('am-size_mode'),
    stdSizeInput: document.getElementById('am-std_size'),
    widthInput: document.getElementById('am-width_mm'),
    heightInput: document.getElementById('am-height_mm'),
    qtyInput: document.getElementById('am-qty'),
    deliverySelect: document.getElementById('am-delivery'),
    deliveryNoteEl: document.getElementById('am-deliveryAreaNote'),
  }) : null;

  form.querySelectorAll('input[name="product"]').forEach(function (r) {
    r.addEventListener('change', function () { updateSizeNote(); mainSizeChoice.apply(); mainDeliveryGuard.update(); mainBacking.apply(); });
  });
  updateSizeNote();
  mainSizeChoice.apply();
  mainBacking.apply();
  if (addMoreForm) {
    addMoreForm.querySelectorAll('input[name="product"]').forEach(function (r) {
      r.addEventListener('change', function () { updateAddMoreSizeNote(); if (addMoreSizeChoice) addMoreSizeChoice.apply(); if (addMoreDeliveryGuard) addMoreDeliveryGuard.update(); if (addMoreBacking) addMoreBacking.apply(); });
    });
    if (addMoreBacking) addMoreBacking.apply();
  }

  // ブラウザの「戻る／進む」で開き直すと、上の初期化のあとでブラウザが前回のラジオの選択を戻すため、
  // 商品と規格サイズ・裏面の表示が食い違う（作業キュー#51で確認）。戻し終わった pageshow で表示を選択に合わせ直す。
  // イベント（input／change）は出さないので、estimate_start などは送らない
  window.addEventListener('pageshow', function () {
    updateSizeNote(); mainSizeChoice.apply(); mainDeliveryGuard.update(); mainBacking.apply();
    if (addMoreForm) {
      updateAddMoreSizeNote();
      if (addMoreSizeChoice) addMoreSizeChoice.apply();
      if (addMoreDeliveryGuard) addMoreDeliveryGuard.update();
      if (addMoreBacking) addMoreBacking.apply();
    }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    // クライアント側のサイズバリデーション（フリー入力の場合のみ。サーバーと同じ判定・同じ文言）
    if (document.getElementById('size_mode').value === 'custom') {
      const w = parseInt(document.getElementById('width_mm').value, 10) || 0;
      const h = parseInt(document.getElementById('height_mm').value, 10) || 0;
      const sizeError = validateCustomSize(getProduct(), w, h);
      if (sizeError) {
        showErrors([sizeError], 'client_size_validation');
        return;
      }
    }

    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="lp-spinner"></span> 計算中...';
    const fd = new FormData(form);
    const deliveryVal = fd.get('delivery');
    fetch('api/estimate.php', { method: 'POST', body: fd })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (data) {
        if (data.ok) {
          data.delivery = deliveryVal;
          attachRawParams(data, fd);
          showResult(data);
        } else {
          showErrors(data.errors || ['エラーが発生しました。'], 'estimate_api_validation');
        }
      })
      .catch(function () { showErrors(['通信エラーが発生しました。しばらくしてからもう一度お試しください。'], 'estimate_api_network'); })
      .finally(function () { submitBtn.disabled = false; submitBtn.textContent = '料金を計算する'; });
  });

  // サーバー再計算用の生パラメータをAPIレスポンスに付与する（estimate-request.php側での金額・納期の再検証に使う）
  function attachRawParams(data, fd) {
    data.product   = fd.get('product') || '';
    data.size_mode = fd.get('size_mode') || 'custom';
    data.std_size  = fd.get('std_size') || '';
    data.width_mm  = fd.get('width_mm') || '';
    data.height_mm = fd.get('height_mm') || '';
    data.backing   = fd.get('backing') || '';
  }

  function fmt(n) { return Number(n).toLocaleString('ja-JP') + '円'; }
  function fmtTotal(n) { return '<strong>' + Number(n).toLocaleString('ja-JP') + '</strong>円'; }

  const WEEKDAY_JA = ['日', '月', '火', '水', '木', '金', '土'];
  // "2026-08-04 17:00" / "2026-08-07" → "8月4日(火)17:00" / "8月7日(金)"
  function formatBatchDate(str) {
    if (!str) return '';
    const parts = str.split(' ');
    const d = new Date(parts[0] + 'T00:00:00');
    if (isNaN(d.getTime())) return '';
    return (d.getMonth() + 1) + '月' + d.getDate() + '日(' + WEEKDAY_JA[d.getDay()] + ')' + (parts[1] || '');
  }

  // DELIVERY_OPTIONS のラベルから「（3〜4営業日）」等の括弧書きを除いた短い名称を返す
  function deliveryShortLabel(key) {
    const label = (DELIVERY_OPTIONS[key] && DELIVERY_OPTIONS[key].label) || '';
    return label.split('（')[0];
  }

  function rateRowHtml(data) {
    if (data.rate_per_sqm === null || data.rate_per_sqm === undefined) return '';
    const baseRate     = Number(data.rate_per_sqm);
    const deliveryRate = Number(data.delivery_rate || 1);
    const totalArea    = Number(data.total_area_sqm).toLocaleString('ja-JP');
    // 納期割増が通常発送（×1.0）のときは倍率適用後も表示上は同じ値になるため内訳を省略する
    // 倍率表記（× 1.6倍等）は客に%計算をさせないため使わず、実額で並べる
    const detail = deliveryRate === 1
      ? '（合計' + totalArea + '㎡）'
      : '（' + deliveryShortLabel('batch') + fmt(baseRate) + '／' + deliveryShortLabel(data.delivery) + '・合計' + totalArea + '㎡）';
    const appliedRate = Math.round(baseRate * deliveryRate);
    return '<div class="lp-estimate__result-row"><dt class="lp-estimate__result-key">適用単価</dt><dd class="lp-estimate__result-val">' +
      fmt(appliedRate) + '/㎡' + detail + '</dd></div>';
  }

  function backingRowHtml(data) {
    if (!data.backing_label) return '';
    return '<div class="lp-estimate__result-row"><dt class="lp-estimate__result-key">裏面</dt><dd class="lp-estimate__result-val">' + esc(data.backing_label) + '</dd></div>';
  }

  function batchRowHtml(data) {
    if (data.delivery !== 'batch' || !data.next_batch_artwork_deadline) return '';
    return '<div class="lp-estimate__result-row"><dt class="lp-estimate__result-key">通常発送</dt><dd class="lp-estimate__result-val">入稿締切：' +
      formatBatchDate(data.next_batch_artwork_deadline) + '<br>入金締切：' + formatBatchDate(data.next_batch_payment_deadline) +
      '<br>発送予定：' + formatBatchDate(data.next_batch_ship_date) + '</dd></div>';
  }

  function renderResults() {
    errorsEl.style.display = 'none';
    resultArea.classList.add('is-visible');

    if (estDestArea) estDestArea.style.display = allEstimates.length > 0 ? '' : 'none';
    updateMultiDestVisibility();

    const multi = allEstimates.length > 1 && isMultiDest();
    let sharedFeeCharged = false;
    let subtotalExclTotal = 0; // 商品税別合計 P
    let shippingExclTotal = 0; // 送料税別合計 F（課金した分のみ）
    let shippingTotal = 0;     // 送料（税込・表示用）。共通届け先・複数届け先のどちらでも課金した分を合算する
    let html = '';
    let pickersHtml = '';

    allEstimates.forEach(function (data, idx) {
      let fee = 0;
      let feeExcl = 0;
      if (data.region) {
        if (multi || !sharedFeeCharged) {
          feeExcl = computeFeeExclForEstimate(data.region, data.home);
          fee = computeFeeInclForEstimate(data.region, data.home);
          sharedFeeCharged = true;
        }
      }
      subtotalExclTotal += Math.round(Number(data.subtotal_excl) || 0);
      shippingExclTotal += feeExcl;
      shippingTotal += fee;

      // 地域セレクトを出すのは「複数箇所ON」または「1商品目」のときだけ
      // （複数箇所OFFの間は1商品目の選択を他の商品にも共有する）
      const showRegionPicker = multi || idx === 0;
      const regionPickerHtml = '<div class="lp-estimate__field" style="margin-top:12px;">' +
          '<label class="lp-estimate__label">お届け先地域<span class="lp-contact__req">必須</span></label>' +
          '<select class="lp-estimate__select est-item-region" data-idx="' + idx + '" style="margin-top:4px;">' + regionOptionsHtml(data.region) + '</select>' +
        '</div>' +
        '<label class="lp-estimate__radio-label" style="margin-top:4px;">' +
          '<input type="checkbox" class="est-item-home" data-idx="' + idx + '"' + (data.home ? ' checked' : '') + '> 個人宅への配送（+' + fmt(HOME_SURCHARGE) + '）' +
        '</label>';
      const feeRowHtml = (multi && fee > 0)
        ? '<div style="display:flex;justify-content:space-between;padding:6px 0;margin-top:2px;border-top:1px solid #eee;font-size:13px;color:#666;">' +
            '<span>送料</span><span style="font-weight:700;color:#111;">' + fmt(fee) + '</span></div>'
        : '';

      if (allEstimates.length === 1) {
        html += '<div class="lp-estimate__result-row"><dt class="lp-estimate__result-key">商品</dt><dd class="lp-estimate__result-val">' + esc(data.product_label) + '</dd></div>' +
          '<div class="lp-estimate__result-row"><dt class="lp-estimate__result-key">サイズ</dt><dd class="lp-estimate__result-val">' + esc(data.size_label) + '</dd></div>' +
          backingRowHtml(data) +
          '<div class="lp-estimate__result-row"><dt class="lp-estimate__result-key">納期</dt><dd class="lp-estimate__result-val">' + esc(data.delivery_label) + '</dd></div>' +
          '<div class="lp-estimate__result-row"><dt class="lp-estimate__result-key">枚数</dt><dd class="lp-estimate__result-val">' + esc(String(data.qty)) + ' 枚</dd></div>' +
          rateRowHtml(data) +
          '<div class="lp-estimate__result-row"><dt class="lp-estimate__result-key">1枚あたり（税別）</dt><dd class="lp-estimate__result-val">' + fmt(data.unit_price_excl) + '</dd></div>' +
          '<div id="addMoreSlot"></div>' +
          batchRowHtml(data);
        if (showRegionPicker) html += regionPickerHtml;
      } else {
        // 複数件: コンパクト表示
        // 「複数箇所にお届け」ON時は商品ブロックの直下に地域セレクトを配置、
        // OFF時（共通届け先）は商品一覧の外・送料の前に1つだけまとめる
        html += '<div class="lp-estimate__result-row" style="flex-direction:column;align-items:stretch;gap:6px;">' +
          '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;">' +
            '<dt class="lp-estimate__result-key">【' + (idx + 1) + '】' + esc(data.product_label) + '</dt>' +
            '<button type="button" class="est-item-remove" data-idx="' + idx + '" aria-label="この見積もりを削除" title="この見積もりを削除" style="flex-shrink:0;background:none;border:none;color:#999;font-size:20px;line-height:1;cursor:pointer;padding:2px 4px;">&times;</button>' +
          '</div>' +
          '<dd class="lp-estimate__result-val" style="text-align:left;">' +
            esc(data.size_label) + (data.backing_label ? ' / ' + esc(data.backing_label) : '') + '&nbsp;/ ' + esc(data.delivery_label) + '&nbsp;/ ' + esc(String(data.qty)) + '枚' +
            (data.rate_per_sqm !== null && data.rate_per_sqm !== undefined ? '&nbsp;（' + fmt(data.rate_per_sqm) + '/㎡）' : '') + '<br>' +
            '<strong>' + fmt(data.total_incl) + '（税込）</strong>' +
          '</dd>';
        if (multi && showRegionPicker) html += regionPickerHtml + feeRowHtml;
        html += '</div>';
        if (idx === 0) html += '<div id="addMoreSlot"></div>';

        if (!multi && showRegionPicker) pickersHtml += regionPickerHtml;
      }
    });

    resultRows.innerHTML = html;
    if (estRegionPickers) estRegionPickers.innerHTML = pickersHtml;

    // 追加フォームを「1商品目」の位置のスロットへ移動する（実体を移動、複製はしない）
    const addMoreSlot = document.getElementById('addMoreSlot');
    if (addMoreSlot && addMoreWrap) addMoreSlot.replaceWith(addMoreWrap);

    // 合計は「商品税別合計＋送料税別合計」に消費税を1回だけ掛けて求める（丸めはここ1回のみ）。
    // 商品ごとに個別丸めした total_incl を積み上げると、商品が2件以上のとき合計が1円ずれることが
    // あるため（送料の税別化_レビュー_2026-09-15 要修正①）、PHP側の estimateReqBuildSummary() と
    // 同じ式に揃える。商品代金（税込）は「合計－送料（税込）」で導出する。
    const taxCombined    = Math.round((subtotalExclTotal + shippingExclTotal) * TAX_RATE); // P+Fへの合算課税（合計の算出用）
    const grandTotal     = subtotalExclTotal + shippingExclTotal + taxCombined;
    const itemsInclTotal = grandTotal - shippingTotal; // 商品代金（税込）＝合計－送料（税込）
    // 画面に出す「消費税（10%）」は商品分のみ（送料分の消費税は含めない）。taxCombined から
    // 直接切り出さず「商品代金（税込）－小計（税別）」で導出することで、この行の足し算が
    // 常にぴったり合う（送料の税別化_指示書_2026-09-14 2-2節）。
    const taxTotal = itemsInclTotal - subtotalExclTotal;
    const hasEstimates = allEstimates.length > 0;

    if (estSubtotalExclRow) estSubtotalExclRow.style.display = hasEstimates ? '' : 'none';
    if (estSubtotalExclVal) estSubtotalExclVal.textContent = hasEstimates ? fmt(subtotalExclTotal) : '';

    if (estTaxRow) estTaxRow.style.display = hasEstimates ? '' : 'none';
    if (estTaxVal) estTaxVal.textContent = hasEstimates ? fmt(taxTotal) : '';

    if (estItemsInclRow) estItemsInclRow.style.display = hasEstimates ? '' : 'none';
    if (estItemsInclVal) estItemsInclVal.textContent = hasEstimates ? fmt(itemsInclTotal) : '';

    if (estShippingRow) {
      const show = hasEstimates && shippingTotal > 0;
      estShippingRow.style.display = show ? '' : 'none';
      if (estShippingVal) estShippingVal.textContent = show ? fmt(shippingTotal) : '';
    }

    if (grandTotalRow) grandTotalRow.style.display = hasEstimates ? '' : 'none';
    if (grandTotalVal) grandTotalVal.innerHTML = fmtTotal(grandTotal);

    if (pdfBtn) pdfBtn.style.display = hasEstimates ? '' : 'none';
    if (pdfNameWrap) pdfNameWrap.style.display = hasEstimates ? '' : 'none';
  }

  function showResult(data) {
    // メインフォーム送信: 1件目として置き換え（入力フォームで選択済みの届け先地域を引き継ぐ）
    data.region = estSharedRegion ? estSharedRegion.value : '';
    data.home = !!(estSharedHome && estSharedHome.checked);
    allEstimates = [data];
    if (estMultiDest) estMultiDest.checked = false;
    // フォームを先に隠してからレンダリング（レイアウトシフト後にスクロール）
    if (estimateInputFields) estimateInputFields.style.display = 'none';
    if (estimateSubmitWrap) estimateSubmitWrap.style.display = 'none';
    if (resetFormBtn) resetFormBtn.style.display = '';
    renderResults();
    // 追加フォームを閉じる
    if (addMoreWrap) addMoreWrap.style.display = 'none';
    if (addMoreBtn) addMoreBtn.textContent = '+ 見積もりを追加する';
    if (addMoreForm) { addMoreForm.reset(); updateAddMoreSizeNote(); if (addMoreSizeChoice) addMoreSizeChoice.apply(); if (addMoreBacking) addMoreBacking.apply(); }
    track('estimate_complete', {
      form_name: 'online_estimate',
      product_type: productType(data.product),
      size_range: sizeRange(data),
      quantity_range: quantityRange(data.qty),
      item_count: 1,
      estimate_count: allEstimates.length,
      value: Math.round(Number(data.total_incl) || 0),
      currency: 'JPY',
      items: [analyticsItem(data)]
    });
  }

  // 商品ごとの地域セレクト・個人宅チェック（resultRows・estRegionPickers両方をカバー）
  resultArea.addEventListener('change', function (e) {
    const idx = e.target.dataset.idx;
    if (idx === undefined) return;
    const data = allEstimates[Number(idx)];
    if (!data) return;
    if (e.target.classList.contains('est-item-region')) {
      data.region = e.target.value;
      if (Number(idx) === 0) syncSharedToItems();
      if (estRegionErrors) estRegionErrors.style.display = 'none';
      renderResults();
    } else if (e.target.classList.contains('est-item-home')) {
      data.home = e.target.checked;
      if (Number(idx) === 0) syncSharedToItems();
      renderResults();
    }
  });

  // 見積もりの削除（複数件表示時のみボタンが出る）
  resultRows.addEventListener('click', function (e) {
    const btn = e.target.closest('.est-item-remove');
    if (!btn) return;
    const idx = Number(btn.dataset.idx);
    allEstimates.splice(idx, 1);
    if (allEstimates.length === 0) {
      resetFormBtn && resetFormBtn.click();
      return;
    }
    updateDestMode();
  });

  if (estMultiDest) estMultiDest.addEventListener('change', updateDestMode);

  // 「← 条件を変更する」でフォームを再表示
  if (resetFormBtn) {
    resetFormBtn.addEventListener('click', function () {
      // 結果側で選択済みの届け先地域（1商品目分）を入力フォームに戻す
      if (allEstimates.length > 0) {
        if (estSharedRegion) estSharedRegion.value = allEstimates[0].region || '';
        if (estSharedHome) estSharedHome.checked = !!allEstimates[0].home;
      }
      allEstimates = [];
      if (estimateInputFields) estimateInputFields.style.display = 'contents';
      if (estimateSubmitWrap) estimateSubmitWrap.style.display = '';
      resetFormBtn.style.display = 'none';
      resultArea.classList.remove('is-visible');
      if (addMoreWrap) addMoreWrap.style.display = 'none';
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // 「+ 見積もりを追加する」トグル
  if (addMoreBtn && addMoreWrap) {
    addMoreBtn.addEventListener('click', function () {
      const willShow = addMoreWrap.style.display === 'none';
      addMoreWrap.style.display = willShow ? '' : 'none';
      addMoreBtn.textContent = willShow ? '− 見積もり追加をやめる' : '+ 見積もりを追加する';
      if (willShow) { updateAddMoreSizeNote(); if (addMoreSizeChoice) addMoreSizeChoice.apply(); if (addMoreBacking) addMoreBacking.apply(); addMoreWrap.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }

  // 追加フォーム送信
  if (addMoreForm) {
    addMoreForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (document.getElementById('am-size_mode').value === 'custom') {
        const w = parseInt(document.getElementById('am-width_mm').value, 10) || 0;
        const h = parseInt(document.getElementById('am-height_mm').value, 10) || 0;
        const sizeError = validateCustomSize(getAddMoreProduct(), w, h);
        if (sizeError) {
          addMoreErrors.innerHTML = '<li>' + esc(sizeError) + '</li>';
          addMoreErrors.style.display = '';
          track('form_error', {
            form_name: 'online_estimate_additional',
            error_count: 1,
            error_type: 'client_size_validation',
            product_type: productType(getAddMoreProduct())
          });
          return;
        }
      }
      const submitBtn2 = document.getElementById('addMoreSubmit');
      submitBtn2.disabled = true;
      submitBtn2.innerHTML = '<span class="lp-spinner"></span> 計算中...';
      const fd = new FormData(addMoreForm);
      const amDeliveryVal = fd.get('delivery');
      fetch('api/estimate.php', { method: 'POST', body: fd })
        .then(function (res) { if (!res.ok) throw new Error(String(res.status)); return res.json(); })
        .then(function (data) {
          if (!data.ok) {
            addMoreErrors.innerHTML = (data.errors || ['エラーが発生しました。']).map(function (e2) { return '<li>' + esc(e2) + '</li>'; }).join('');
            addMoreErrors.style.display = '';
            track('form_error', {
              form_name: 'online_estimate_additional',
              error_count: (data.errors || []).length || 1,
              error_type: 'estimate_api_validation',
              product_type: productType(getAddMoreProduct())
            });
            return;
          }
          data.delivery = amDeliveryVal;
          attachRawParams(data, fd);
          addMoreErrors.style.display = 'none';
          if (!isMultiDest() && allEstimates.length > 0) {
            data.region = allEstimates[0].region || '';
            data.home = !!allEstimates[0].home;
          } else {
            data.region = '';
            data.home = false;
          }
          const wasMultiDest = isMultiDest();
          allEstimates.push(data);
          track('estimate_complete', {
            form_name: 'online_estimate_additional',
            product_type: productType(data.product),
            size_range: sizeRange(data),
            quantity_range: quantityRange(data.qty),
            item_count: 1,
            estimate_count: allEstimates.length,
            value: Math.round(Number(data.total_incl) || 0),
            currency: 'JPY',
            items: [analyticsItem(data)]
          });
          updateDestMode();
          addMoreForm.reset();
          if (estMultiDest) estMultiDest.checked = wasMultiDest;
          updateAddMoreSizeNote();
          if (addMoreSizeChoice) addMoreSizeChoice.apply();
          if (addMoreBacking) addMoreBacking.apply();
          addMoreWrap.style.display = 'none';
          addMoreBtn.textContent = '+ 見積もりを追加する';
          const resultTitle = resultArea.querySelector('.lp-estimate__result-title');
          if (resultTitle) resultTitle.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function () {
          addMoreErrors.innerHTML = '<li>通信エラーが発生しました。しばらくしてからもう一度お試しください。</li>';
          addMoreErrors.style.display = '';
          track('form_error', {
            form_name: 'online_estimate_additional',
            error_count: 1,
            error_type: 'estimate_api_network',
            product_type: productType(getAddMoreProduct())
          });
        })
        .finally(function () {
          submitBtn2.disabled = false;
          submitBtn2.textContent = 'この内容を追加する';
        });
    });
  }

  // 全商品で地域が選択されているか確認し、未選択があればエラーを出して false を返す
  // （注文ボタン・見積書PDFボタンで共通。送料の入っていない注文・見積書を出さないため）
  function ensureRegionsSelected() {
    const missingRegion = allEstimates.some(function (d) { return !d.region; });
    if (!missingRegion) return true;
    if (estRegionErrors) {
      estRegionErrors.style.display = '';
      estRegionErrors.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    track('form_error', {
      form_name: 'online_estimate',
      error_count: allEstimates.filter(function (d) { return !d.region; }).length,
      error_type: 'shipping_region_missing',
      product_type: allEstimates.length === 1 ? productType(allEstimates[0].product) : 'mixed'
    });
    return false;
  }

  // 商品・サイズ・（裏面）・納期・枚数・合計の順で組み立てる（サーバー側 estimateReqBuildItemText() と行の並びを揃える）
  function itemTextLines(d, prefix) {
    const lines = [
      (prefix || '') + '商品：' + d.product_label,
      'サイズ：' + d.size_label,
    ];
    if (d.backing_label) lines.push('仕様：' + d.backing_label);
    lines.push(
      '納期：' + d.delivery_label,
      '枚数：' + d.qty + '枚',
      '合計（税込）：' + fmt(d.total_incl)
    );
    return lines;
  }

  // 合計（送料込・税込）。renderResults() と同じ式（商品・送料とも税別で合算し、最後に一度だけ課税する）。
  // サーバー側は estimate-request.php・estimate-pdf.php で estimateReqBuildSummary() により
  // 必ず再計算するため、ここでの値は初期表示・計測用（改竄されても実際の請求・見積書には影響しない）。
  function computeGrandTotal(multi) {
    const subtotalExclSum = allEstimates.reduce(function (s, d) { return s + Math.round(Number(d.subtotal_excl) || 0); }, 0);
    let sharedFeeChargedForTotal = false;
    const shippingExclSum = allEstimates.reduce(function (s, d) {
      if (!d.region) return s;
      if (!multi && sharedFeeChargedForTotal) return s;
      sharedFeeChargedForTotal = true;
      return s + computeFeeExclForEstimate(d.region, d.home);
    }, 0);
    const grandTax = Math.round((subtotalExclSum + shippingExclSum) * TAX_RATE);
    return subtotalExclSum + shippingExclSum + grandTax;
  }

  // 送料（税込）の合計。computeGrandTotal() と同じ課金のしかた（複数箇所ONなら商品ごと、OFFなら1回だけ）
  function computeShippingInclTotal(multi) {
    let charged = false;
    return allEstimates.reduce(function (s, d) {
      if (!d.region) return s;
      if (!multi && charged) return s;
      charged = true;
      return s + computeFeeInclForEstimate(d.region, d.home);
    }, 0);
  }

  // er_items（/estimate-request と /api/estimate-pdf.php の両方へ送る）を組み立てる。
  // サーバー側は生パラメータから金額を再計算するため、cost・text は初期表示用。
  function buildHandoffItems() {
    return allEstimates.map(function (d) {
      return {
        text: itemTextLines(d).join('\n'),
        cost: Math.round(Number(d.total_incl) || 0),
        region: d.region || '',
        home: !!d.home,
        // サーバー側再計算用の生パラメータ（estimate-request.php で cost を再計算・検証する）
        product: d.product || '',
        size_mode: d.size_mode || 'custom',
        std_size: d.std_size || '',
        width_mm: d.width_mm || '',
        height_mm: d.height_mm || '',
        qty: d.qty || 1,
        delivery: d.delivery || 'batch',
        backing: d.backing || '',
      };
    });
  }

  if (toContactBtn) {
    toContactBtn.addEventListener('click', function () {
      if (allEstimates.length === 0) return;
      const multi = allEstimates.length > 1 && isMultiDest();

      if (!ensureRegionsSelected()) return;

      const summaryParts = allEstimates.map(function (d, idx) {
        const prefix = multi ? '【' + (idx + 1) + '】' : '';
        return itemTextLines(d, prefix).join('\n');
      });
      const summary = summaryParts.join('\n\n---\n\n');
      const grandTotal = computeGrandTotal(multi);
      const items = buildHandoffItems();

      const handoffForm  = document.getElementById('estimateHandoffForm');
      const summaryField = document.getElementById('er-summary-handoff');
      const totalField   = document.getElementById('er-total-handoff');
      if (summaryField) summaryField.value = summary;
      if (totalField)   totalField.value   = String(grandTotal);
      if (erItemsHandoff) erItemsHandoff.value = JSON.stringify(items);
      if (erMultiDestHandoff) erMultiDestHandoff.value = multi ? '1' : '0';
      track('begin_checkout', {
        form_name: 'online_order',
        product_type: allEstimates.length === 1 ? productType(allEstimates[0].product) : 'mixed',
        item_count: items.length,
        value: grandTotal,
        currency: 'JPY',
        items: allEstimates.map(analyticsItem)
      });
      if (handoffForm)  handoffForm.submit();
    });
  }

  // 見積書PDFのダウンロード（作業キュー#25）。金額はサーバー側で再計算するため、送るのは
  // 生パラメータ入りの er_items・複数箇所フラグ・宛名だけ（合計金額は送らない）
  if (pdfBtn) {
    pdfBtn.addEventListener('click', function () {
      if (allEstimates.length === 0) return;
      if (!ensureRegionsSelected()) return;
      const multi = allEstimates.length > 1 && isMultiDest();
      const items = buildHandoffItems();

      const pdfForm       = document.getElementById('estimatePdfForm');
      const pdfItems      = document.getElementById('er-items-pdf');
      const pdfMultiDest  = document.getElementById('er-multi-dest-pdf');
      const pdfAddressee  = document.getElementById('pdf-addressee');
      const addresseeInput = document.getElementById('estPdfAddressee');
      if (pdfItems) pdfItems.value = JSON.stringify(items);
      if (pdfMultiDest) pdfMultiDest.value = multi ? '1' : '0';
      if (pdfAddressee) pdfAddressee.value = addresseeInput ? addresseeInput.value : '';

      const grandTotal = computeGrandTotal(multi);
      // 宛名・メールアドレス等の個人情報は送らない。value は注文イベント（begin_checkout）と同じ
      // 送料込の合計にそろえる（見積書PDFに印字される合計も送料込）。商品代金は items_value で別に送る
      track('estimate_pdf_download', {
        item_count: items.length,
        value: grandTotal,
        // 画面の「商品代金（税込）」と同じく「合計－送料（税込）」で出す（Σ商品ごとの税込額だと
        // 商品が2件以上のとき1円ずれることがあるため。レビュー追記 2026-09-28）
        items_value: grandTotal - computeShippingInclTotal(multi),
        currency: 'JPY'
      });
      if (pdfForm) pdfForm.submit();
    });
  }

  function showErrors(errors, errorType) {
    resultArea.classList.remove('is-visible');
    errorsEl.innerHTML = errors.map(function (e) { return '<li>' + esc(e) + '</li>'; }).join('');
    errorsEl.style.display = '';
    track('form_error', {
      form_name: 'online_estimate',
      error_count: errors.length,
      error_type: errorType || 'validation_or_request',
      product_type: productType(getProduct())
    });
  }

  function esc(s) {
    return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

})();
